/* eslint-disable react/prop-types */

/* eslint-disable prettier/prettier */
import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-8.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(8.000000, -1.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 0.124200)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0.0003 0.876 24.702 0.876 24.702 29.9794 0.0003 29.9794"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M24.7023,12.6384 C24.7023,7.0754 20.7173,0.8754 12.3433,0.8754 C3.9693,0.8754 0.0003,7.0754 0.0003,12.6384 C0.0003,17.0724 2.9363,24.8264 10.1483,27.2464 L8.9553,29.4224 C8.7933,29.7344 8.9553,29.9794 9.3423,29.9794 L15.4253,29.9794 C15.7963,29.9794 15.9573,29.7344 15.7963,29.4224 L14.5213,27.2464 C21.5723,24.7114 24.7023,17.0724 24.7023,12.6384"
})), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.6661,33.307 L13.5851,33 L11.2941,33 L11.4881,33.549 C11.8391,34.543 11.6131,35.6 11.0681,36.502 C10.4221,37.572 10.3151,38.871 10.4231,40.116 C10.4291,40.18 10.4291,40.229 10.4341,40.293 C10.4691,40.822 10.9701,41.22 11.5041,41.213 C12.0681,41.241 12.5671,40.81 12.5851,40.245 C12.5861,40.204 12.5871,40.116 12.5851,40.083 C12.5251,39.094 12.6341,38.102 13.0691,37.212 C13.7901,36.045 14.0051,34.636 13.6661,33.307"
})))), 'CategoryAF', {
  viewBox: '0 0 25 40'
});